<div class="container" *ngIf="coinOverviewObs | async as screenSize">
    <!-- Desktop View -->
    <div class="mt-5 coin-overview" *ngIf="screenSize === 'desktop'">
        <div class="row">
            <!-- Price Related Information -->
            <div class="column price_related ps-0">
                <div class="card price_card h-100">
                    <h3 class="inner-title px-3 pt-3 pb-2 mb-0">
                        {{ 'COIN.OVERVIEW.PRICE_TILE.PRICE_RELATED_INFORMATION' | translate }}
                    </h3>
                    <div class="row mt-3 pl-2 accordion-inner-text">
                        <!-- Latest Price -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.LAST_PRICE' | translate }}</span>
                            <br />
                            <strong>
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.price,
                                        precision: coinDetail.precision
                                    }"></ng-container>
                            </strong>
                        </div>

                        <!-- 24H Change -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_CHANGE' | translate }}</span>
                            <br />
                            <strong [ngClass]="coinDetail.is_up ? 'text-success' : 'text-danger'">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_24h.price_change,
                                        precision: coinDetail.precision
                                    }"></ng-container>
                                <br />
                                ({{ coinDetail.is_up ? '+' : '-'
                                }}{{ coinDetail.change ?? 0 | absValue | number : '1.2-2' }}%)
                            </strong>
                        </div>

                        <!-- 7D Change -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.7D_CHANGE' | translate }}</span>
                            <br />
                            <strong [ngClass]="coinDetail.stats_7d.price_change >= 0 ? 'text-success' : 'text-danger'">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_7d.price_change,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                                <br />
                                <ng-container *ngIf="coinDetail.stats_7d.percent_change as weeklyChange">
                                    <span>({{ weeklyChange >= 0 ? '+' : '-' }}</span>
                                    <span>{{ weeklyChange | absValue | number : '1.2-2' }}%)</span>
                                </ng-container>
                            </strong>
                        </div>

                        <!-- 30D Change -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.30D_CHANGE' | translate }}</span>
                            <br />
                            <strong [ngClass]="coinDetail.stats_30d.price_change >= 0 ? 'text-success' : 'text-danger'">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_30d.price_change,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                                <br />
                                <ng-container *ngIf="coinDetail.stats_30d.percent_change as monthlyChange">
                                    <span>({{ monthlyChange >= 0 ? '+' : '-' }}</span>
                                    <span>{{ monthlyChange | absValue | number : '1.2-2' }}%)</span>
                                </ng-container>
                            </strong>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <!-- 24H High -->
                        <div class="col-6 col-md-3 ">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_HIGH' | translate }}</span>
                            <br />
                            <strong class="text-success">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_24h.high,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                            </strong>
                        </div>

                        <!-- 24H Low -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_LOW' | translate }}</span>
                            <br />
                            <strong class="text-danger">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_24h.low,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                            </strong>
                        </div>

                        <!-- All Time High -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.ALL_TIME_HIGH' | translate }}</span>
                            <br />
                            <strong class="text-success">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_all_time.high,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                                <br />
                            </strong>
                            <p>- {{ coinDetail.stats_all_time.high_timestamp | date }}</p>
                        </div>

                        <!-- All Time Low -->
                        <div class="col-6 col-md-3">
                            <span>{{ 'COIN.OVERVIEW.PRICE_TILE.ALL_TIME_LOW' | translate }}</span>
                            <br />
                            <strong class="text-danger">
                                <ng-container
                                    [ngTemplateOutlet]="priceTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.stats_all_time.low,
                                        precision: coinDetail.fixedPrecision
                                    }"></ng-container>
                                <br />
                            </strong>
                            <p>- {{ coinDetail.stats_all_time.low_timestamp | date }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Volume and Market Cap -->
            <div class="column volume_market pe-0">
                <div class="card price_card h-100">
                    <h3 class="inner-title px-3 pt-3 pb-2 mb-0">
                        {{ 'COIN.OVERVIEW.VOLUME_TILE.VOLUME_AND_MARKET_CAP' | translate }}
                    </h3>
                    <div class="row mt-3 pl-2 accordion-inner-text">
                        <!-- 24H Volume -->
                        <div class="col-6">
                            <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.24H_VOLUME' | translate }}</span>
                            <br />
                            <strong> {{ coinDetail.volume | number }} {{ coinDetail.coin_symbol | uppercase }} </strong>
                        </div>
                        <!-- Market Cap -->
                        <div class="col-6">
                            <span>{{ 'GENERAL.MARKET_CAP' | translate }}</span>
                            <br />
                            <strong>
                                <ng-container
                                    [ngTemplateOutlet]="placeValueTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.mc
                                    }"></ng-container>
                            </strong>
                        </div>
                    </div>
                    <div class="row mt-3 pl-0 pr-0">
                        <!-- Fully Diluted Market Cap -->
                        <div class="col-6">
                            <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.FULLY_DILUTED_MARKET_CAP' | translate }}</span>
                            <br />
                            <strong>
                                <ng-container
                                    [ngTemplateOutlet]="placeValueTemplate"
                                    [ngTemplateOutletContext]="{
                                        value: coinDetail.supply.fully_diluted_market_cap
                                    }"></ng-container>
                            </strong>
                        </div>
                        <!-- Volume / Market Cap -->
                        <div class="col-6">
                            <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.VOLUME_BY_MARKET_CAP' | translate }}</span>
                            <br />
                            <strong> {{ volumeByMarketCap }} </strong>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Supply -->
            <div class="column supply px-0">
                <div class="card price_card h-100">
                    <div class="row">
                        <div class="col-md-2 d-flex align-items-center">
                            <h3 class="inner-title px-3 mb-0">
                                {{ 'COIN.OVERVIEW.SUPPLY_TILE.SUPPLY' | translate }}
                            </h3>
                        </div>
                        <!-- Circulating Supply -->
                        <div class="col-md-3">
                            <div>
                                <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.CIRCULATING_SUPPLY' | translate }}</span> <br />
                                <strong>
                                    <span *ngIf="coinDetail.cs">
                                        {{ coinDetail.cs | number : '1.2-2' }} {{ coinDetail.coin_symbol | uppercase }}
                                    </span>
                                    <span *ngIf="!coinDetail.cs">--</span>
                                </strong>
                            </div>
                            <div class="position-relative">
                                <ng-container *ngIf="progressBarValue">
                                    <ngb-progressbar [value]="progressBarValue">
                                        <div class="progress-value" [ngStyle]="{ left: progressPercent }">
                                            {{ progressPercent }}
                                        </div>
                                    </ngb-progressbar>
                                </ng-container>
                            </div>
                        </div>
                        <div class="col-md-5">
                            <div class="row pl-2">
                                <!-- Max Supply -->
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.MAX_SUPPLY' | translate }}</span>
                                    <br />
                                    <strong>
                                        {{ (coinDetail.supply.max_supply | number) ?? '--' }}
                                        <span class="ps-1" *ngIf="coinDetail.supply.max_supply">{{
                                            coinDetail.coin_symbol | uppercase
                                        }}</span>
                                    </strong>
                                </div>
                                <!-- Total Supply -->
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.TOTAL_SUPPLY' | translate }}</span>
                                    <br />
                                    <strong>
                                        <span *ngIf="coinDetail.supply.total_supply">
                                            {{ coinDetail.supply.total_supply | number }}
                                            {{ coinDetail.coin_symbol | uppercase }}
                                        </span>
                                        <span *ngIf="!coinDetail.supply.total_supply">--</span>
                                    </strong>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Mobile View -->
    <div class="container overview-accordion mt-3 mx-0 p-0" *ngIf="screenSize === 'mobile'">
        <div class="card border-0 h-100">
            <ngb-accordion #acc="ngbAccordion" class="accordion" activeIds="ngb-panel-0" [closeOthers]="true">
                <ngb-panel class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <h2 class="accordion-header">
                            {{ 'COIN.OVERVIEW.PRICE_TILE.PRICE_RELATED_INFORMATION' | translate }}
                        </h2>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="accordion-body pl-2 pb-3">
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.LAST_PRICE' | translate }}</span>
                                    <br />
                                    <strong>
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.price,
                                                precision: coinDetail.precision
                                            }"></ng-container>
                                    </strong>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_CHANGE' | translate }}</span>
                                    <br />
                                    <strong
                                        [ngClass]="
                                            coinDetail.stats_24h.price_change >= 0 ? 'text-success' : 'text-danger'
                                        ">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_24h.price_change,
                                                precision: coinDetail.precision
                                            }"></ng-container>
                                        ({{ coinDetail.is_up ? '+' : '-'
                                        }}{{ coinDetail.change ?? 0 | absValue | number : '1.2-2' }}%)
                                    </strong>
                                </div>
                            </div>
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.7D_CHANGE' | translate }}</span>
                                    <br />
                                    <strong
                                        [ngClass]="
                                            coinDetail.stats_7d.price_change >= 0 ? 'text-success' : 'text-danger'
                                        ">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_7d.price_change,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                        <ng-container *ngIf="coinDetail.stats_7d.percent_change as weeklyChange">
                                            <span>({{ weeklyChange >= 0 ? '+' : '-' }}</span>
                                            <span>{{ weeklyChange | absValue | number : '1.2-2' }}%)</span>
                                        </ng-container>
                                    </strong>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.30D_CHANGE' | translate }}</span>
                                    <br />
                                    <strong
                                        [ngClass]="
                                            coinDetail.stats_30d.price_change >= 0 ? 'text-success' : 'text-danger'
                                        ">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_30d.price_change,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                        <ng-container *ngIf="coinDetail.stats_30d.percent_change as monthlyChange">
                                            <span>({{ monthlyChange >= 0 ? '+' : '-' }}</span>
                                            <span>{{ monthlyChange | absValue | number : '1.2-2' }}%)</span>
                                        </ng-container>
                                    </strong>
                                </div>
                            </div>
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_HIGH' | translate }}</span>
                                    <br />
                                    <strong class="text-success">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_24h.high,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                    </strong>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.24H_LOW' | translate }}</span>
                                    <br />
                                    <strong class="text-danger">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_24h.low,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                    </strong>
                                </div>
                            </div>
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.ALL_TIME_HIGH' | translate }}</span>
                                    <br />
                                    <strong class="text-success">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_all_time.high,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                    </strong>
                                    <p>- {{ coinDetail.stats_all_time.high_timestamp | date }}</p>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.PRICE_TILE.ALL_TIME_LOW' | translate }}</span>
                                    <br />
                                    <strong class="text-danger">
                                        <ng-container
                                            [ngTemplateOutlet]="priceTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.stats_all_time.low,
                                                precision: coinDetail.fixedPrecision
                                            }"></ng-container>
                                    </strong>
                                    <p>- {{ coinDetail.stats_all_time.low_timestamp | date }}</p>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <h2 class="accordion-header">
                            {{ 'COIN.OVERVIEW.VOLUME_TILE.VOLUME_AND_MARKET_CAP' | translate }}
                        </h2>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="accordion-body pb-3">
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.24H_VOLUME' | translate }}</span>
                                    <br />
                                    <strong>
                                        {{ coinDetail.volume | number }} {{ coinDetail.coin_symbol | uppercase }}
                                    </strong>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'GENERAL.MARKET_CAP' | translate }}</span>
                                    <br />
                                    <strong>
                                        <ng-container
                                            [ngTemplateOutlet]="placeValueTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.mc
                                            }"></ng-container>
                                    </strong>
                                </div>
                            </div>
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.FULLY_DILUTED_MARKET_CAP' | translate }}</span>
                                    <br />
                                    <strong>
                                        <ng-container
                                            [ngTemplateOutlet]="placeValueTemplate"
                                            [ngTemplateOutletContext]="{
                                                value: coinDetail.supply.fully_diluted_market_cap
                                            }"></ng-container>
                                    </strong>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.VOLUME_TILE.VOLUME_BY_MARKET_CAP' | translate }}</span>
                                    <br />
                                    <strong> {{ volumeByMarketCap }} </strong>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
                <ngb-panel class="accordion-item">
                    <ng-template ngbPanelTitle>
                        <h2 class="accordion-header">{{ 'COIN.OVERVIEW.SUPPLY_TILE.SUPPLY' | translate }}</h2>
                    </ng-template>
                    <ng-template ngbPanelContent>
                        <div class="accordion-body">
                            <div class="row mt-3 pl-2 accordion-inner-text">
                                <div class="col-12">
                                    <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.CIRCULATING_SUPPLY' | translate }}</span>
                                    <br />
                                    <strong *ngIf="coinDetail.cs">
                                        {{ coinDetail.cs | number : '1.2-2' }}
                                        <p>{{ coinDetail.coin_symbol | uppercase }}</p>
                                    </strong>
                                    <strong *ngIf="!coinDetail.cs">--</strong>
                                    <div class="position-relative">
                                        <ng-container *ngIf="progressBarValue">
                                            <ngb-progressbar [value]="progressBarValue">
                                                <div class="progress-value" [ngStyle]="{ left: progressPercent }">
                                                    {{ progressPercent }}
                                                </div>
                                            </ngb-progressbar>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-2 pl-2 supply-info">
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.MAX_SUPPLY' | translate }}</span>
                                    <br />
                                    <strong>{{ (coinDetail.supply.max_supply | number) ?? '--' }}</strong>
                                    <p *ngIf="coinDetail.supply.max_supply">{{ coinDetail.coin_symbol | uppercase }}</p>
                                </div>
                                <div class="col-6">
                                    <span>{{ 'COIN.OVERVIEW.SUPPLY_TILE.TOTAL_SUPPLY' | translate }}</span>
                                    <br />
                                    <strong *ngIf="coinDetail.supply.total_supply">
                                        {{ coinDetail.supply.total_supply | number }}
                                        <p>{{ coinDetail.coin_symbol | uppercase }}</p>
                                    </strong>
                                    <strong *ngIf="!coinDetail.supply.total_supply">--</strong>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </ngb-panel>
            </ngb-accordion>
        </div>
    </div>
</div>

<ng-template #priceTemplate let-value="value" let-precision="precision">
    <div class="d-inline-flex">
        {{ value | fiatValue : usdExchangeRate | currency : currencySymbol : 'symbol' : '1.0-' + precision }}
    </div>
</ng-template>

<ng-template #placeValueTemplate let-value="value">
    <div class="d-inline-flex">
        {{
            value
                | fiatValue : usdExchangeRate
                | placeValue : getPlaceValueNotation(value)
                | currency : currencySymbol : 'symbol' : '1.1-1'
        }}
        <span [ngSwitch]="getPlaceValueNotation(value)">
            <span *ngSwitchCase="'billion'">B</span>
            <span *ngSwitchCase="'million'">M</span>
            <span *ngSwitchCase="'thousand'">K</span>
            <div *ngSwitchDefault></div>
        </span>
    </div>
</ng-template>
